// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__Cxyvu","additionalInfo":"AgreementModal_additionalInfo__3MNqM"};